import { AuthForm } from "routes/auth/components/AuthForm";

export const Login: React.FC = () => {
  return <AuthForm mode="login" />;
};
